import { DateTime } from 'luxon';

const DATE_TIME_OUTPUT_FORMAT = { locale: 'en-gb' };
export const SYDNEY_TIMEZONE = 'Australia/Sydney';

/**
 * Creates a date string from a timestamp seconds
 *
 * @param seconds The seconds of the timestamp
 * @param displayMask The format of the output
 * @param toTimezone
 * @returns {*}
 */
export default function (
  seconds,
  displayMask = 'dd/MM/yyyy',
  toTimezone = SYDNEY_TIMEZONE
) {
  if (isNaN(seconds)) {
    return undefined;
  }

  return DateTime.fromMillis(seconds * 1000, {
    zone: toTimezone
  }).toFormat(displayMask, { locale: 'en-gb' });
}
